import React, { useEffect, useState } from "react";
import { HelmetProvider } from "react-helmet-async";
import {
  Routes,
  Route,
  BrowserRouter,
  HashRouter,
  useNavigate,
} from "react-router-dom";

import LandingPage from "./pages/LandingPage";
import Games from "./pages/GamesPage";
import About from "./pages/AboutPage";
import Careers from "./pages/CarrersPage";
import Contact from "./pages/ContactPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import BlogPosts from "./components/Blog/BlogPosts";
import BlogPost from "./components/Blog/BlogPost";
import ScrollToTop from "./components/ScrollToTop";
import NewLandingPage from "./pages/NewLandingPage/NewLandingPage";

function HashRedirect() {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (window.location.hash.startsWith("#/")) {
      const clean = window.location.hash.replace("#", "");

      // Replace the URL in the browser
      window.history.replaceState(null, "", clean);

      // IMPORTANT: Tell React Router to re-navigate
      navigate(clean, { replace: true });
    }
  }, [navigate]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <HashRouter>
        {/* <HashRedirect /> */}
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/games" element={<Games />} />
          <Route path="/about" element={<About />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/blog" element={<BlogPosts />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/kidsLearningGame" element={<NewLandingPage />} />
        </Routes>
      </HashRouter>
    </HelmetProvider>
  );
}

export default App;
